export const APOLLO_STATE_SCRIPT_ID = '__APOLLO_STATE__'
export const INITIAL_I18N_STORE_SCRIPT_ID = 'initialI18nStore'
export const PUBLIC_ENV_SCRIPT_ID = 'publicEnv'
